import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {bootstrapApplication} from '@angular/platform-browser';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {Util} from "./app/modules/util/util";

// Standalone imports for /direct routes (Angular 20 style)
import {AppDirectComponent} from './app/modules/app-direct.component';
import {directConfig} from './app/direct.config';

if (environment.production) {
  enableProdMode();
}

const path = window.location.pathname || '';

// Detect direct path (outside the main app)
if (Util.isStandaloneDirect(path)) {
  // Angular 20: Standalone component bootstrap
  bootstrapApplication(AppDirectComponent, directConfig)
    .catch(err => console.error(err));
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
